<template>
  <MenuItems :items="menuItems"/>
</template>

<script>
import MenuItems from '../../components/MenuItems.vue'
export default {
    components:{
        MenuItems
    },
    data: ()=>({
        menuItems: [
            {
                title: "Autenticación CSJ",
                icon: "fas fa-user-circle",
                url: "/login/signin",
            },
            {
                title: "Autent. Otras Entidades",
                icon: "far fa-user-circle",
                url: "/login/token",
            }
        ]        
    })
}
</script>

<style>

</style>